exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Mos5-7_3_0 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 128px;\n  margin-bottom: 64px;\n  overflow: hidden; }\n  ._3IBvB-7_3_0 > img {\n    max-width: 200px; }\n  ._3etLW-7_3_0 {\n    margin-top: 24px;\n    color: #000000;\n    font-weight: bold;\n    font-size: 20px; }\n  ._1syCh-7_3_0 {\n    margin-top: 16px;\n    font-size: 16px;\n    line-height: 21px;\n    width: 400px;\n    text-align: center;\n    color: #4d4d4d; }\n  .G8uNX-7_3_0 {\n    margin-top: 24px; }\n", ""]);

// Exports
exports.locals = {
	"core-empty-state": "_3Mos5-7_3_0",
	"core-empty-state__image": "_3IBvB-7_3_0",
	"core-empty-state__title": "_3etLW-7_3_0",
	"core-empty-state__description": "_1syCh-7_3_0",
	"core-empty-state__actions": "G8uNX-7_3_0"
};